export default __webpack_public_path__ + "static/media/coat_1.67f15b68.jpg";